(function () {
  'use strict';

  function readText(node) {
    return node ? String(node.textContent || '').trim() : '';
  }

  function setStatus(panel, message) {
    var status = panel ? panel.querySelector('[data-hanezza-copy-status]') : null;
    if (status) status.textContent = message || '';
  }

  function copyText(text) {
    if (!text) return Promise.reject(new Error('empty-copy-text'));
    if (!navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') {
      return Promise.reject(new Error('clipboard-unavailable'));
    }
    return navigator.clipboard.writeText(text);
  }


  function children(node) {
    return node && node.childNodes ? Array.prototype.slice.call(node.childNodes) : [];
  }

  function tagName(node) {
    return node && node.tagName ? String(node.tagName).toLowerCase() : '';
  }

  function safeUrl(value) {
    var url = String(value || '').trim();
    if (!/^(https?:\/\/|\/(?!\/)|#)/i.test(url)) return '';
    return url.replace(/\)/g, '%29').replace(/\s/g, '%20');
  }

  function inlineMarkdown(node) {
    if (!node) return '';
    if (node.nodeType === 3) return String(node.nodeValue || '').replace(/\s+/g, ' ');
    if (node.nodeType !== 1) return '';
    var tag = tagName(node);
    if (/^(script|style|button|iframe|noscript)$/.test(tag)) return '';
    if (tag === 'br') return '  \n';
    if (tag === 'img') {
      var src = safeUrl(node.getAttribute('src'));
      var alt = String(node.getAttribute('alt') || '').replace(/[\[\]]/g, '');
      return src ? '![' + alt + '](' + src + ')' : '';
    }
    var value = children(node).map(inlineMarkdown).join('');
    if (tag === 'strong' || tag === 'b') return value.trim() ? '**' + value.trim() + '**' : '';
    if (tag === 'em' || tag === 'i') return value.trim() ? '*' + value.trim() + '*' : '';
    if (tag === 'code') return String.fromCharCode(96) + value.trim().replace(new RegExp(String.fromCharCode(96), 'g'), '\\'+String.fromCharCode(96)) + String.fromCharCode(96);
    if (tag === 'a') {
      var href = safeUrl(node.getAttribute('href'));
      return href ? '[' + value.trim().replace(/[\[\]]/g, '') + '](' + href + ')' : value;
    }
    return value;
  }

  function tableMarkdown(table) {
    var rows = [];
    function visit(node) {
      if (tagName(node) === 'tr') {
        var cells = children(node).filter(function (child) {
          return tagName(child) === 'td' || tagName(child) === 'th';
        }).map(function (cell) {
          return inlineMarkdown(cell).trim().replace(/\|/g, '\\|');
        });
        if (cells.length) rows.push(cells);
        return;
      }
      children(node).forEach(visit);
    }
    visit(table);
    if (!rows.length) return '';
    var width = rows.reduce(function (max, row) { return Math.max(max, row.length); }, 0);
    function formatted(row) {
      var cells = row.slice();
      while (cells.length < width) cells.push('');
      return '| ' + cells.join(' | ') + ' |';
    }
    return [formatted(rows[0]), formatted(Array(width).fill('---'))]
      .concat(rows.slice(1).map(formatted)).join('\n');
  }

  function listMarkdown(node, ordered) {
    var items = children(node).filter(function (child) { return tagName(child) === 'li'; });
    return items.map(function (li, index) {
      var prefix = ordered ? String(index + 1) + '. ' : '- ';
      return prefix + inlineMarkdown(li).trim().replace(/\n\s*/g, ' ');
    }).join('\n');
  }

  function blockMarkdown(node) {
    if (!node) return '';
    if (node.nodeType === 3) return String(node.nodeValue || '').trim();
    if (node.nodeType !== 1) return '';
    var tag = tagName(node);
    if (/^(script|style|button|iframe|noscript)$/.test(tag)) return '';
    if (/^h[1-6]$/.test(tag)) return '#'.repeat(Number(tag.slice(1))) + ' ' + inlineMarkdown(node).trim();
    if (tag === 'p') return inlineMarkdown(node).trim();
    if (tag === 'ul' || tag === 'ol') return listMarkdown(node, tag === 'ol');
    if (tag === 'table') return tableMarkdown(node);
    if (tag === 'blockquote') return blockMarkdownChildren(node).split('\n').map(function (line) { return '> ' + line; }).join('\n');
    if (tag === 'pre') return String.fromCharCode(96,96,96) + '\n' + (node.textContent || '').trim() + '\n' + String.fromCharCode(96,96,96);
    if (tag === 'hr') return '---';
    if (tag === 'img') return inlineMarkdown(node);
    return blockMarkdownChildren(node);
  }

  function blockMarkdownChildren(node) {
    return children(node).map(blockMarkdown).filter(function (part) { return part && part.trim(); }).join('\n\n');
  }

  function buildMarkdown(sourceText, articleContent) {
    if (!articleContent) throw new Error('missing-article-body');
    var fullText = blockMarkdownChildren(articleContent).trim();
    if (!fullText) throw new Error('missing-article-body');
    var source = String(sourceText || '').trim();
    var marker = '\n## Source of truth';
    var index = source.indexOf(marker);
    if (index >= 0) {
      return source.slice(0, index).trim() + '\n\n## Tam Metin\n\n' + fullText + '\n\n' + source.slice(index + 1).trim() + '\n';
    }
    return source + '\n\n## Tam Metin\n\n' + fullText + '\n';
  }

  function moveIntoArticle(panel) {
    if (!panel) return;

    var article = document.querySelector('.article-hanezza__wrapper');
    if (!article) return;

    var tags = article.querySelector('.article-hanezza__tags');
    var share = article.querySelector('.article-hanezza__share');

    if (tags) {
      tags.insertAdjacentElement('afterend', panel);
      return;
    }

    if (share && share.parentNode) {
      share.parentNode.insertBefore(panel, share);
      return;
    }

    article.appendChild(panel);
  }

  function setupPanel(panel) {
    if (!panel || panel.dataset.hanezzaArticleAiReady === 'true') return;
    panel.dataset.hanezzaArticleAiReady = 'true';

    moveIntoArticle(panel);

    var markdownSource = panel.querySelector('[data-hanezza-markdown-source]');
    var promptSource = panel.querySelector('[data-hanezza-chatgpt-prompt]');
    var copyButton = panel.querySelector('[data-hanezza-copy-markdown]');
    var chatLink = panel.querySelector('[data-hanezza-chatgpt]');
    var openButton = panel.querySelector('[data-hanezza-open-markdown]');
    var preview = panel.querySelector('[data-hanezza-markdown-preview]');
    var previewContent = panel.querySelector('[data-hanezza-markdown-preview-content]');
    var closeButton = panel.querySelector('[data-hanezza-close-markdown]');

    function currentMarkdown() {
      return buildMarkdown(readText(markdownSource), document.querySelector('.article-hanezza__content'));
    }

    if (copyButton) {
      copyButton.addEventListener('click', function () {
        var markdown;
        try { markdown = currentMarkdown(); }
        catch (error) { setStatus(panel, 'Tam makale içeriği bulunamadı.'); return; }
        copyText(markdown).then(function () {
          setStatus(panel, 'Makalenin tamamı Markdown olarak kopyalandı.');
        }).catch(function () {
          setStatus(panel, "Kopyalama kullanılamıyor. 'Markdown'u aç' ile metni seçebilirsiniz.");
        });
      });
    }

    if (openButton) {
      openButton.addEventListener('click', function () {
        var markdown;
        try { markdown = currentMarkdown(); }
        catch (error) { setStatus(panel, 'Tam makale içeriği bulunamadı.'); return; }
        if (!preview || !previewContent || typeof preview.showModal !== 'function') {
          setStatus(panel, 'Markdown önizlemesi bu tarayıcıda desteklenmiyor.');
          return;
        }
        previewContent.textContent = markdown;
        if (!preview.open) preview.showModal();
        setStatus(panel, 'Markdown önizlemesi açıldı.');
      });
    }

    if (closeButton && preview) {
      closeButton.addEventListener('click', function () {
        if (preview.open && typeof preview.close === 'function') preview.close();
      });
    }

    if (chatLink) {
      chatLink.addEventListener('click', function () {
        copyText(readText(promptSource)).then(function () {
          setStatus(panel, "Soru kopyalandı; ChatGPT'ye yapıştırın.");
        }).catch(function () {
          setStatus(panel, 'ChatGPT açıldı. Makale bağlantısını sohbete yapıştırabilirsiniz.');
        });
      });
    }
  }

  function bootstrap() {
    var panels = document.querySelectorAll('[data-hanezza-article-ai-actions]');
    for (var i = 0; i < panels.length; i += 1) setupPanel(panels[i]);
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = { buildMarkdown: buildMarkdown, setupPanel: setupPanel, bootstrap: bootstrap };
  }
  if (typeof document === 'undefined') return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap, { once: true });
  } else {
    bootstrap();
  }
})();
